import { useEffect, useState } from "react";
import {
  enrichDailyMetricsData,
  enrichMetricsData
} from "../Components/MetricsReport/MetricsReport.utils";
import webAPIUtils from "../utils/WebAPIUtils";
import logger from "../utils/LoggerFrontend";
import { filterChartDataByDate } from "../PagesUser/Campaign/DataVisualization/utils";

const initialDataStructure = {
  statusBreakdown: [],
  platformBreakdown: [],
  ratingsBreakdown: [],
  averageRating: 0
};

export const useEnrichedDailyData = (campaignId, range) => {
  const [metrics, setMetrics] = useState(initialDataStructure);
  const [campaignData, setCampaignData] = useState({});

  useEffect(() => {
    const getMetricData = async () => {
      if (!campaignId) return;

      const response = await webAPIUtils.getDailyCandidateMetrics(campaignId);
      const { candidateMetrics, campaignData } = response.payload;
      const enrichedData = enrichDailyMetricsData({ metrics: candidateMetrics, range });

      logger.debug("useEnrichedData:getDailyCandidateMetrics", "returned data: ", {
        payload: response.payload,
        enrichedData
      });

      setMetrics(enrichedData);
      setCampaignData(campaignData);
    };

    getMetricData();
  }, [campaignId, range]);

  return { campaignData, metrics };
};

export const usePerformanceMetrics = (campaignId, range) => {
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    const getPerformanceMetrics = async () => {
      if (!campaignId) return;

      const metrics = await webAPIUtils.getPerformanceMetrics(campaignId);
      const filtered = filterChartDataByDate(metrics.targetPerformance, range?.from, range?.to);

      setChartData(filtered);
    };

    getPerformanceMetrics();
  }, [campaignId, range?.from, range?.to]);

  return chartData;
};

export const useEnrichedData = (campaignId) => {
  const [metrics, setMetrics] = useState();

  useEffect(() => {
    const getMetricData = async () => {
      if (!campaignId) return;

      const response = await webAPIUtils.getCampaignCandidateMetrics(campaignId);
      const enrichedData = enrichMetricsData({ metrics: response.payload });

      logger.debug("useEnrichedData:getCampaignCandidateMetrics", "returned data: ", {
        payload: response.payload,
        enrichedData
      });

      setMetrics(enrichedData);
    };

    getMetricData();
  }, [campaignId]);

  return metrics;
};
